

class TFQModel {
    constructor(qTxt, qImgSrc) {
        this.qTxt = qTxt;
        this.qImgSrc = qImgSrc;
        this.type = 0;
        this.selectedStyle = {}
        this.showImg = true
        this.showTxt = true
    }



    getJsonObj = () => {

        return { qTxt: this.qTxt, qImgSrc: this.qImgSrc, type: this.type }
    }

    getJsCode = () => {
        return {
            qTxt: this.qTxt,
            qImgSrc: this.qImgSrc,
            type: this.type
        }
    }

    getAsJson = () => {
        return {
            qTxt: this.qTxt,
            qImgSrc: this.qImgSrc,
            type: this.type,
            selectedStyle: this.selectedStyle
        }
    }

    initFromJson = (obj) => {
        this.qTxt = obj.qTxt;
        this.qImgSrc = obj.qImgSrc;
        this.type = obj.type;
        this.showImg = obj.showImg
        this.showTxt = obj.showTxt

        this.selectedStyle = obj.selectedStyle
        this.styleModification()
    }


    initFromJsonTest4You = (obj) => {

        this.qTxt = obj.qTxt;

        // this.styleIndex = this.styleArr.length - 1
        this.qTxt = window.toAbsAllImgSrcs(this.qTxt)

        this.showImg = false
        this.showTxt = true
    }

    styleModification = () => {

        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"

    }

    // getReportAsJson=()=>{
    //     let obj={}
    //     obj.qTxt = this.qTxt;
    //     obj.qImgSrc = this.qImgSrc;
    //     obj.type = this.type;
    //     obj.showImg=this.showImg
    //     obj.showTxt=this.showTxt

    //     obj.selectedStyle=this.selectedStyle
    // }

    getReportAsJson = () => {
        let obj = {}
        obj.qTxt = this.qTxt;
        obj.qImgSrc = this.qImgSrc;
        obj.type = this.type;
        obj.showImg = this.showImg
        obj.showTxt = this.showTxt

        obj.selectedStyle = this.selectedStyle

        return obj
    }

    initReportFromJson = (obj) => {
        this.qTxt = obj.qTxt;
        this.qImgSrc = obj.qImgSrc;
        this.type = obj.type;
        this.showImg = obj.showImg
        this.showTxt = obj.showTxt

        this.selectedStyle = obj.selectedStyle

        // this.selectedStyle.imgStyle.border=""
        this.styleModification()

    }



}


export default TFQModel